import React, { useEffect, useState } from 'react';

import {
  DateInputsPopover,
  StreamIdsSelectPopover,
  GeolocationFilter,
  EventTypesCheckboxesPopover,
} from '@vlabs/shared/components/filters-panel';
import { Control, Group, useWindowSize } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectFacecoverVersion } from '@vlapps/point/src/app/store/selectors';

import { SCORE_FIELDS } from '../ScoreFields';
import st from './VideoAnalyticFilterForm.module.sass';

function VideoAnalyticFilterFormComponent({ facecoverVersion }) {
  const { t } = useTranslation();
  const { lpStreamOptions, resetFilters, setFilterCounts } = useFormContext();
  const windowSize = useWindowSize();

  const [counts, setCounts] = useState({});
  const handleCountChange = (key, count) => {
    setCounts((prev) => {
      if (prev[key] === count) return prev;
      return { ...prev, [key]: count };
    });
  };

  useEffect(() => {
    const totalCount = Object.values(counts).reduce((acc, n) => acc + (n || 0), 0);
    setFilterCounts(totalCount);
  }, [counts, setFilterCounts]);

  return (
    <div
      className={st.FilterForm}
      data-testid="filtersPanel"
    >
      <Group
        gapSize="0"
        vertical
      >
        <EventTypesCheckboxesPopover
          facecoverVersion={facecoverVersion}
          onCountChange={handleCountChange}
          scoreFields={SCORE_FIELDS}
        />
        <div className={st.Divider} />
        <DateInputsPopover
          customNameGte="event_create_time__gte"
          customNameLt="event_create_time__lt"
          onCountChange={handleCountChange}
        />
        <div className={st.Divider} />
        <StreamIdsSelectPopover
          onCountChange={handleCountChange}
          streamIdsOptions={lpStreamOptions}
        />
        <div className={st.Divider} />
        <GeolocationFilter
          hasMap
          onCountChange={handleCountChange}
        />
        <div className={st.Divider} />
      </Group>

      <div className={st.ButtonPanel}>
        <Control.Button
          className={st.Button}
          data-testid="FilterForm.clearButton"
          kind="negative"
          onClick={resetFilters}
          size={windowSize.width < 1920 ? 'small' : 'medium'}
        >
          {t('button.clear')}
        </Control.Button>
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    facecoverVersion: selectFacecoverVersion(state),
  }),
)(VideoAnalyticFilterFormComponent);
